import React from 'react';
import { useTournament } from '@/hooks/use-tournament';
import { useLanguage } from '@/hooks/use-language';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users } from 'lucide-react';

export const BenchPanel: React.FC = () => {
  const { tournamentState } = useTournament();
  const { language } = useLanguage();

  const isAmericano = tournamentState.tournamentType === 'americano' || tournamentState.tournamentType === 'team_americano';
  const benchPlayers = isAmericano
    ? (tournamentState.americanoPlayers || []).filter(p => (p as any).isOnBench)
    : (tournamentState.players || []).filter(p => (p as any).isOnBench);

  if (!benchPlayers.length) return null;

  return (
    <Card className="border-orange-200 bg-orange-50">
      <CardHeader className="bg-orange-100 py-3">
        <CardTitle className="text-orange-800 flex items-center gap-2 text-sm">
          <Users className="h-4 w-4" />
          {language === 'no' ? 'Benken' : 'Bench'}
        </CardTitle>
      </CardHeader>
      <CardContent className="py-3">
        <div className="flex flex-wrap gap-2">
          {benchPlayers.map((player: any) => (
            <div key={player.id} className="bg-orange-200 text-orange-800 px-3 py-1 rounded-full text-sm font-medium">
              {player.name}
            </div>
          ))}
        </div>
        <p className="text-xs text-orange-600 mt-2">
          {language === 'no' ? 'Disse spillerne spiller neste runde' : 'These players will play next round'}
        </p>
      </CardContent>
    </Card>
  );
};
